import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExitToApp as ExitToAppIcon } from '@mui/icons-material';
import { BottomSection, UserName, LogoutButton } from './styledComponents';
import { logoutUserAction } from '../../../../store/authSlice';
import { useAppDispatch } from '../../../../hooks';

const DrawerFooter: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const logoutUser = async () => {
    try {
      await dispatch(logoutUserAction()); // wait for token removal and dispatch
      navigate('/login');
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  return (
    <BottomSection>
      <UserName>User Name</UserName>
      <LogoutButton startIcon={<ExitToAppIcon />} onClick={async () => await logoutUser()}>
        Logout
      </LogoutButton>
    </BottomSection>
  );
};

export default DrawerFooter;
